<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose, onMounted } from "vue";
import { useRouter } from 'vue-router'
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";

const router = useRouter();

const baseModal = ref(null);
const resolvePromise = ref(null);
const emit = defineEmits(['confirm']);

const modalContent = ref([])
const okButtonText = ref("확인");

const loaded = ref(false)
const content = ref(null);


const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = () => {
  baseModal.value.close();
  emit('confirm', true);
  if (resolvePromise) {
    resolvePromise.value(true); // 모달 확인 클릭 시 Promise를 resolve
  }
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

defineExpose({
  show,
})
</script>
<template>
  <Modal ref="baseModal" class="vld-parent">
    <div class="modal-inner">
      <div class="modal-body">
        <p>특별채용관 인재정보에 공개 할 수 있는</p>
        <p><b class="red">이력서는 1개만 가능</b>합니다.</p>
        <div class="mt-sm">
          <p>해당 이력서를 공개 하시겠습니까?</p>
          <p><span class="red">나머지는 비공개 처리 됩니다.</span></p>
        </div>
      </div>
      <div class="modal-footer">
        <KSAPrimaryButton text="취소" @click="cancel" />
        <KSAPrimaryButton text="인재정보 공개" @click="confirm" />
      </div>
    </div>
  </Modal>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  .close {
    top: -20px !important;
    right: -10px !important;;
  }
  .modal-body {
    p {
      margin-bottom: 0;
    }
  }
  .modal-footer {
    display: block;
  }
}
</style>